import { ChatMessageVerificationError } from '../../../errors/ChatMessageVerificationError';
import { showAlert } from '../../../slices/alertSlice';
import { TThunkAction } from '../../../types/redux/thunk';
import { ETelemetryEvents } from '../../../types/telemetry';
import { setFirstMessageFailed } from '../actions';
import { EFirstMessageResponseStatus, IAssertDependencies, TFirstMessageResponse } from '../types';

export const assertWrongCaptchaTokenStatus =
  (response: TFirstMessageResponse, { domain, telemetry }: IAssertDependencies): TThunkAction<void> =>
  (dispatch, _, { logger }) => {
    if (response.status === EFirstMessageResponseStatus.WrongCaptchaToken) {
      telemetry.increment(ETelemetryEvents.ChatFirstMessageSendWrongCaptchaToken);

      dispatch(setFirstMessageFailed());
      dispatch(showAlert({ message: 'Не удалось подтвердить, что вы не робот. Обновите страницу и попробуйте снова' }));

      const error = new ChatMessageVerificationError({
        message: 'Не удалось отправить первое сообщение: бэкенд отклонил токен капчи',
        domain,
        details: { errorCode: response.status },
      });

      logger.error(error);
    }
  };
